module.exports = __webpack_public_path__ + "img/temp_idc2.b8e612ac.jpg";